module.exports = __webpack_public_path__ + "assets/76c0653203ebfca4a6e90fa42a36a273.png";